import { gql } from 'graphql-request';
import useSWRMutation from 'swr/mutation';
import { useCustomerIdToken } from '@hooks/customer/useCustomer';
import { NoteFragment, NoteProps, useRecipeNotes } from '@hooks/customer/useRecipeNotes';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import {
  DefaultVariables,
  GraphQLRequestWithTokenProps,
  requestWithTokenRequired,
} from '@repo/ui/src/utils/graphql-request';

interface Props extends DefaultVariables {
  recipeId: string;
}

interface Arg {
  comment: string;
  id: string;
}

export const updateRecipeNote = gql`
  ${NoteFragment}
  mutation UpdateRecipeNote($id: ID!, $comment: String!, $recipeId: String!) {
    updateNote(input: { id: $id, comment: $comment, recipeId: $recipeId }) {
      ...Note
    }
  }
`;
const fetcher = async (
  { variables, ...props }: GraphQLRequestWithTokenProps<Props>,
  { arg: { comment, id } }: { arg: Arg },
) => {
  const data = await requestWithTokenRequired({
    ...props,
    variables: {
      ...variables,
      comment,
      id,
    },
  });
  return data?.updateNote as NoteProps;
};

export const useUpdateRecipeNote = ({ recipeId }: Props) => {
  const { mutate } = useRecipeNotes({ recipeId });
  const idToken = useCustomerIdToken();
  const { locale } = useCurrentUrl();

  return useSWRMutation(
    {
      document: updateRecipeNote,
      variables: {
        recipeId,
      },
      idToken,
      locale,
    },
    fetcher,
    {
      onSuccess: (result) => {
        if (result?.id) {
          mutate((notes) => notes?.map((note) => (note.id === result.id ? result : note)), {
            revalidate: false,
          });
        }
      },
    },
  );
};
